<template>
    <div>
        <img class="matrix" src="~@public/img/hotApply/wechartTrain/matrix.png">
        <div>
            <van-cell-group>
                <van-field required readonly clickable label="地区选择" placeholder="请选择地区" :value="matrix" is-link
                           input-align="right" @click="showPickermatrix = true"/>
                <van-popup v-model="showPickermatrix" position="bottom">
                    <van-picker show-toolbar :columns="matrixList" value-key="title" @cancel="showPickermatrix = false"
                                @confirm="onConfirmIdType"/>
                </van-popup>
            </van-cell-group>
        </div>
        <div>
            <ul class="matters-box" >
                <li v-for="items in matrixName">
                    <span @click="See(items.url)">
                        <img :src="items.src">
                        <p>{{items.alt}}</p>
                    </span>
                </li>
            </ul>
        </div>
        <div>
            <ul class="matters-box" v-show="matrixShow">
                <li v-for="items in matrixList[0].list">
                    <span @click="See(items.url)">
                        <img :src="items.src">
                        <p>{{items.alt}}</p>
                    </span>
                </li>
            </ul>
        </div>
    </div>

</template>

<script>
    import {CellGroup, Picker, Field, Popup} from 'vant'
    import {WeChatTrain} from "@/views/hotApply/wechatTrain/wct"

    export default {
        name: "WeChatTrain",
        components: {
            [CellGroup.name]: CellGroup,
            [Field.name]: Field,
            [Popup.name]: Popup,
            [Picker.name]: Picker
        },
        data() {
            return {
                matrix: '武汉市',
                showPickermatrix: false,
                matrixList: WeChatTrain,
                matrixName: '',
                matrixShow:true,
            }
        },
        methods: {
            onConfirmIdType(value) {
                this.matrixShow = false
                this.matrix = value.title
                this.matrixName = value.list
                this.showPickermatrix = false
            },
            See(e) {
                window.location.href = e
            }
        }
    }
</script>

<style scoped>
    .matrix {
        width: 100%;
        height: 100%;
    }
    img{
        width: 1.5rem;
        height: 1.5rem;
    }
    ul {
        display: flex;
        flex-wrap: wrap;
        padding: 0 .5rem;
    }
    li {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 1.65rem;
        margin: 0.5rem .35rem .35rem 0.2rem;
        text-align: center;
    }
</style>